<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span>{{ $t('User Management') }}</span>
          </div>

        </div>

        <box boxClass="alt">
          <tableTopActions class="alt">
            <dspInput v-model="searchText"
                      @changed="searchText=$event"
                      :placeholder="$t('Search')"
                      class="search-input"></dspInput>
            <dropdown v-model="searchField" :showSearch="false" :options="searchFieldsList">
              <template v-slot:header="header">
                <span>{{ header.value.title }}</span>
              </template>
              <template v-slot:item="item">
                <span>{{ item.option.title }}</span>
              </template>
            </dropdown>

            <dropdown v-model="status" :showSearch="false" :options="statusList">
              <template v-slot:header="header">
                <span>{{ header.value.title }}</span>
              </template>
              <template v-slot:item="item">
                <span>{{ item.option.title }}</span>
              </template>
            </dropdown>

            <actionOptions :sections="Object.keys(sections)"
                           :options="sections"
                           :showSelectAll="true"
                           @change="onColumnsChange($event)"/>


          </tableTopActions>
          <perfect-scrollbar class="table-scroll">
            <b-table hover
                     ref="usersTable"
                     :fields="tableFields"
                     :items="usersProvider"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :show-empty="true"
                     :empty-text="$t('No data to display')">


              <template v-for="field in sortableFields">
                <template :slot="'HEAD_' + field.key">
                  <sortableColumnHead :title="field.label" :key="field.key"/>
                </template>
              </template>

              <template slot="ID" slot-scope="data">
                            <span v-bind:class="{ 'admin-user-id-offline': !data.item.isOnline }"
                                  class="admin-user-id-online">{{ data.item.id }}</span>
              </template>
              <template slot="name" slot-scope="data">
                <router-link :to="{ name: 'agency.accounts.edit', params: { id: data.item.id } }">
                  {{ data.item.firstName }} {{ data.item.lastName }}
                </router-link>
              </template>
              <template slot="email" slot-scope="data">
                {{ data.item.email }}
              </template>
              <template slot="company" slot-scope="data">
                {{ data.item.company }}
              </template>
              <!--              <template slot="spend" slot-scope="data">-->
              <!--                {{ data.item.spend | finance4}}-->
              <!--              </template>-->

              <template slot="balance" slot-scope="data">
                {{ data.item.balance | finance }}
              </template>

              <template slot="lastLogin" slot-scope="data">
                {{ data.item.lastLogin | date }}
              </template>
              <template slot="reg" slot-scope="data">
                {{ data.item.reg | date }}
              </template>

            </b-table>
          </perfect-scrollbar>
          <b-pagination v-if="pagination.totalPages > 1"
                        v-model="pagination.currentPage"
                        :total-rows="pagination.totalRows"
                        :per-page="pagination.perPage"
                        align="right"
                        aria-controls="data-table"
                        @change="changePage"></b-pagination>
        </box>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import sortableColumnHead from '@/components/shared/sortableColumnHead.vue';
import moment from 'moment';
import { datesToPeriod } from '@/lib/periodToDates';

export default {
  name: 'admin.users',
  components: {
    sortableColumnHead,
  },
  data: function () {
    return {
      searchText: '',
      sortDesc: true,
      sortBy: 'id',

      searchFieldsList: [{
        value: 'id',
        title: this.$t('ID'),
      }, {
        value: 'firstname',
        title: this.$t('First Name'),
      }, {
        value: 'lastname',
        title: this.$t('Last Name'),
      }, {
        value: 'email',
        title: this.$t('Email'),
      }, {
        value: 'company',
        title: this.$t('Company'),
      },],

      searchField: {},

      statusList: [{
        value: null,
        title: this.$t('All'),
      }, {
        value: 1,
        title: this.$t('Active'),
      }, {
        value: 0,
        title: this.$t('Not active'),
      },],

      status: {},

      rolesFilter: ['All roles'],
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 100,
        totalPages: 1,
      },
      sections: {
        selected: [],
        general: [// {
          //   name: this.$t("Spend"),
          //   checked: false,
          //   disabled: false,
          //   checkID: "spend",
          //   sortable: false
          // },
          {
            name: this.$t('Date of registration'),
            checked: false,
            disabled: false,
            checkID: 'createdAt',
            sortable: true
          }, {
            name: this.$t('Last login'),
            checked: false,
            disabled: false,
            checkID: 'lastLogin',
            sortable: true
          },

        ],

      },
      defaultExtraColumns: ['Reg'],

    };
  },
  computed: {

    tableFields: {
      get () {
        let fields = [];
        fields.push({
          key: 'ID',
          label: this.$t('ID'),
          class: 'admin-user-id',
          sortable: true
        });
        fields.push({
          key: 'name',
          label: this.$t('Name'),
          class: 'admin-user-name',
          sortable: true
        });
        fields.push({
          key: 'email',
          label: this.$t('Email'),
          class: 'admin-user-name',
          sortable: true
        });
        fields.push({
          key: 'company',
          label: this.$t('Company'),
          class: 'admin-user-name',
          sortable: true
        });
        fields.push({
          key: 'balance',
          label: this.$t('Balance'),
          class: 'admin-user-balance',
          sortable: true
        });

        this.sections.selected.map(column => {
          fields.push({
            key: column['checkID'],
            label: column['name'],
            sortable: column['sortable'],
            sortDirection: 'desc',
          });
        });

        return fields;
      },
      set () {
      },
    },

    statRange () {
      return [this.fromDate, this.toDate];
    },
    sortableFields () {
      return this.tableFields.filter(item => item.sortable).map(item => ({
        key: item.key,
        label: item.label
      }));
    },
  },

  mounted () {
    let columns = JSON.parse(localStorage.getItem('users-table-columns'));
    if (!columns) {
      localStorage.setItem('users-table-columns', JSON.stringify(this.defaultExtraColumns));
      columns = this.defaultExtraColumns;
    }

    this.onColumnsChange(columns);
  },

  watch: {
    searchText () {
      this.pagination.currentPage = 1;
      this.refreshTableDebounced();
    },

    searchField () {
      if (this.searchText) {
        this.pagination.currentPage = 1;
        this.$refs.usersTable.refresh();
      }
    },
    status () {
      this.pagination.currentPage = 1;
      this.$refs.usersTable.refresh();
    },
  },

  created () {
    if (!this.$auth.hasRole('agency')) {
      this.$router.push({ name: 'dashboard' });
    }
    this.searchField = this.searchFieldsList.find(() => true);

    this.status = this.statusList.find(() => true);
  },

  methods: {
    onColumnsChange (columns) {
      this.sections.selected = [];
      let selectedPlain = [];
      columns.map(column => {
        if (this.sections.selected.find(i => i.checkID === column)) {
          return;
        }
        let col = this.sections.general.find(i => i.checkID === column);
        // if (!col) {
        //     col = this.sections.performance.find(i => i.checkID === column);
        // }
        if (!col) {
          return;
        }
        col.checked = true;
        selectedPlain.push(col.checkID);
        this.sections.selected.push(col);
      });
      localStorage.setItem('users-table-columns', JSON.stringify(selectedPlain));
    },

    onPeriodChange (event) {
      this.fromDate = moment(event.dateStart);
      this.toDate = moment(event.dateEnd);
      this.rangeName = datesToPeriod(event.dateStart, event.dateEnd);
    },

    changePage (pageNo) {
      this.pagination.currentPage = pageNo;
      this.$refs.usersTable.refresh();
    },

    refreshTableDebounced: debounce(function () {
      this.$refs.usersTable.refresh();
    }, 1000),

    usersProvider (ctx) {
      const params = new URLSearchParams();
      params.append('page', this.pagination.currentPage);

      let search = '';
      let searchFields = '';

      if (this.searchText) {
        search = search + ';' + this.searchField.value + ':' + this.searchText;
        searchFields = searchFields + ';' + this.searchField.value + ':like';
      }

      if (this.status.value !== null) {
        search = search + ';isActive:' + this.status.value;
        searchFields = searchFields + ';isActive:=';
      }

      let sortBy = ctx.sortBy;

      params.append('search', search);
      params.append('searchJoin', 'and');
      params.append('searchFields', searchFields);
      params.append('orderBy', sortBy === 'name' ? 'firstName' : sortBy );
      params.append('sortedBy', ctx.sortDesc ? 'desc' : 'asc');
      params.append('append', 'totalSpent;firstDep;lastDep;topUps;ltv');
      params.append('where', 'ownerId;' + this.$auth.user().id);

      return this.axios.get('agency-users', { params: params })
          .then(response => {
            this.pagination.currentPage = response.data.meta.pagination.current_page;
            this.pagination.perPage = response.data.meta.pagination.per_page;
            this.pagination.totalRows = response.data.meta.pagination.total;
            this.pagination.totalPages = response.data.meta.pagination.total_pages;
            let items = response.data.data.map(item => ({
              id: item.id,
              isActive: item.isActive,
              firstName: item.firstName,
              lastName: item.lastName,
              email: item.email,
              company: item.company,
              balance: item.balance,

              lastLogin: item.lastLogin,
              createdAt: item.createdAt
            }));
            return items;
          })
          .catch(error => {
            this.pagination.currentPage = 0;
            this.pagination.perPage = 0;
            this.pagination.totalRows = 0;
            this.items = [];

            this.$backendErrors(error, 'Error');

            return [];
          });
    },
  }

};
</script>

<style lang="scss">
.automated-dates {
  .mdrp-root {
    width: 100%;
  }
}
</style>

